var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras['custom' + _vm.index + 'Display' + _vm.type].display == 1)?_c('div',{staticClass:"custom-img top-nav",class:_vm.type},[_c('a',{style:({
      cursor:
        _vm.extras['custom' + _vm.index + 'ImgUrl' + _vm.type].model.replace(
          'https://',
          ''
        ).length > 0
          ? 'pointer'
          : 'default',
    }),attrs:{"target":_vm.extras['custom' + _vm.index + 'ImgUrl' + _vm.type].model.replace('https://', '')
        .length > 0
        ? '_blank'
        : '',"href":_vm.extras['custom' + _vm.index + 'ImgUrl' + _vm.type].model.replace('https://', '')
        .length > 0
        ? _vm.extras['custom' + _vm.index + 'ImgUrl' + _vm.type].model
        : 'javascript:void(0)'}},[_c('img',{attrs:{"src":_vm.extras['custom' + _vm.index + 'Img' + _vm.type].src,"alt":""}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }